export default __webpack_public_path__ + "static/media/wallet_connect.e6760085.svg";